/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import * as Store from '@apply/store';
import { ShowIf } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
import { alertModal } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { BusinessAndPeopleApi } from '@apply/api';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { LoadPanel } from 'devextreme-react/load-panel';
import { IReferencePanel } from '@apply/api/src/api/BusinessAndPeopleApi';
import { BusinessReferenceTypeOptions } from '../constants/BusinessReferenceTypeOptions';
import { NumericFormat } from 'react-number-format';

export interface IEditReferencesModalProps {
    isOpen: boolean;
    save: (data: IReferencePanel, isUpdated: boolean) => void;
    close: () => void;
    applicationInsights: ApplicationInsights;
    selectedBusinessId: number;
    referencePanel?: IReferencePanel;
}

export interface IValidationMessage {
    hasErrors?: boolean;
    messages?: [
        {
            message: string;
        },
    ];
}

export const EditReferencesModal: React.FC<IEditReferencesModalProps> = ({
    isOpen,
    close,
    save,
    applicationInsights,
    selectedBusinessId,
    referencePanel,
}) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(applicationInsights);

    const [validation, set_validation] = useState<IValidationMessage>();
    const [saveEnabled, set_saveEnabled] = useState(false);
    const [canContinue, set_canContinue] = useState(false);

    const [businessId, set_businessId] = useState(0);

    const [referenceType, set_referenceType] = useState<string>();
    const [companyName, set_companyName] = useState<string>();
    const [contactName, set_contactName] = useState<string>();
    const [phoneNumber, set_phoneNumber] = useState<string>();
    const [email, set_email] = useState<string>();

    const styles = {
        noPadding: {
            padding: 0,
        },
        checkbox: {
            marginRight: '5px',
        },
    };

    useEffect(() => {
        set_businessId(selectedBusinessId);
    }, [selectedBusinessId]);

    const resetState = () => {
        set_companyName(undefined);
        set_contactName(undefined);
        set_email(undefined);
        set_referenceType(undefined);
        set_phoneNumber(undefined);
    };

    const handleSave = () => {
        resetState();
        save(
            {
                companyName,
                contactName,
                email,
                phoneNumber,
                type: referenceType,
                id: referencePanel ? referencePanel.id : 0,
            },
            referencePanel ? true : false
        );
    };
    const handleClose = () => {
        resetState();
        close();
    };
    useEffect(() => {
        if (referencePanel) {
            console.log(referencePanel);
            set_companyName(referencePanel.companyName);
            set_contactName(referencePanel.contactName);
            set_email(referencePanel.email);
            set_referenceType(referencePanel.type);
            set_phoneNumber(referencePanel.phoneNumber);
        }
    }, [referencePanel]);

    useEffect(() => {
        let fieldsValid = false;

        fieldsValid = companyName !== '' && contactName !== '' && email !== '' && phoneNumber?.length === 10;

        set_canContinue(fieldsValid);
    }, [companyName, contactName, email, phoneNumber]);

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '500px', maxWidth: '80vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>{!referencePanel ? 'Add Reference' : 'Edit Reference'}</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-content '>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={styles.noPadding}
                                        >
                                            <div
                                                className='scrollable-content'
                                                style={{ margin: '10px' }}
                                            >
                                                <ShowIf showIf={validation?.hasErrors}>
                                                    {validation?.messages?.map((m) => {
                                                        return (
                                                            <div className='row'>
                                                                <div className='columns small-12 large-12'>
                                                                    <div>
                                                                        <span
                                                                            style={{
                                                                                color: 'red',
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faExclamationTriangle}
                                                                                style={{
                                                                                    color: 'red',
                                                                                }}
                                                                            />
                                                                            &nbsp;
                                                                            <span
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: m.message,
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </ShowIf>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='name'>
                                                            Reference Type <span className='req'>*</span>
                                                        </label>
                                                        <select
                                                            id='referencesTypes'
                                                            value={
                                                                referenceType ? referenceType : BusinessReferenceTypeOptions[0]
                                                            }
                                                            onChange={(x) => set_referenceType(x.target.value)}
                                                        >
                                                            {Object.values(BusinessReferenceTypeOptions).map((x, index) => {
                                                                return (
                                                                    <option
                                                                        key={`${index}-${x}`}
                                                                        value={x.id}
                                                                    >
                                                                        {x.text}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='companyName'>
                                                            Company Name <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                Company name on business cards or website
                                                            </span>
                                                        </span>
                                                        <input
                                                            type='text'
                                                            id='companyName'
                                                            value={companyName}
                                                            onChange={(e) => set_companyName(e.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='contactName'>
                                                            Contact Name <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>Full name i.e. John Smith</span>
                                                        </span>
                                                        <input
                                                            type='text'
                                                            id='contactName'
                                                            value={contactName}
                                                            onChange={(e) => set_contactName(e.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='phone'>
                                                            Phone Number <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                10 digit phone number, including area code, without symbols e.g.
                                                                5551234567.
                                                            </span>
                                                        </span>
                                                        <span>
                                                            <NumericFormat
                                                                format='(###) ###-####'
                                                                mask='_'
                                                                // id={selector}
                                                                // aria-labelledby={`legend-${selector}`}
                                                                placeholder='(212) 555-1212'
                                                                name='phone'
                                                                value={phoneNumber}
                                                                required={true}
                                                                onValueChange={(values) => {
                                                                    set_phoneNumber(values.value);
                                                                }}
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='email'>Email</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The email address for your reference contact.
                                                            </span>
                                                        </span>
                                                        <input
                                                            type='email'
                                                            id='email'
                                                            value={email}
                                                            onChange={(e) => set_email(e.target.value)}
                                                            required={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal-content-actions'>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{ width: '150px' }}
                                                    onClick={handleClose}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{ width: '150px' }}
                                                    onClick={handleSave}
                                                    disabled={!canContinue || !saveEnabled}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </div>
    );
};
